import { PlanningEventLogGeneratedEntity } from "./generated/PlanningEventLogGeneratedEntity";

export abstract class PlanningEventLogEntity extends PlanningEventLogGeneratedEntity {
    // Comment to preserve new line
}
